var e;!function(e){e.Explicit="explicitly_set",e.Sampler="client_sampler",e.Rate="client_rate",e.Inheritance="inheritance"}(e||(e={}));export{e as TransactionSamplingMethod};
